export const LOCAL_DOMAIN = "http://localhost:3003";
export const DEV_DOMAIN = "https://shovelhousedev.ca";
export const PROD_DOMAIN = "https://shovelhouse.com";

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const BACKEND_URL =
  ENVIRONMENT === "local"
    ? LOCAL_DOMAIN
    : ENVIRONMENT === "production"
      ? PROD_DOMAIN
      : DEV_DOMAIN;
export const BACKEND_API_URL = `${BACKEND_URL}/api`;
export const BACKEND_STRIPE_URL = `${ENVIRONMENT === "production" ? PROD_DOMAIN : DEV_DOMAIN}/api/stripe`;
export const BACKEND_STRIPE_KEY =
  ENVIRONMENT === "production"
    ? "pk_live_51Pv37VRvOCLWc0jZVIG5GsUMtj3wKl1Kefl4Cr1YdWNWiG1W0N1rwQaqCZhLp81Dn1Bchltomcf3VJZ1KqiVL2MB00XzOzqwGx"
    : ENVIRONMENT === "development"
      ? "pk_test_51Pv37VRvOCLWc0jZXjSgH518nFoSDP7ML1fTVdJHsfniJGfIbbzEKQW4Co8JzfCApZ0UwDMm79fRQwIgCM5FuLbU008V8ZHFdQ"
      : "pk_test_51Pv37VRvOCLWc0jZXjSgH518nFoSDP7ML1fTVdJHsfniJGfIbbzEKQW4Co8JzfCApZ0UwDMm79fRQwIgCM5FuLbU008V8ZHFdQ";
